"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAccessPointSchedulesByRole = selectAccessPointSchedulesByRole;
var hasura_1 = require("../hasura");
var main_api_1 = require("../main-api");
var timetable_verification_1 = require("../timetable-verification");
// This function can be used to compute the applied AP schedules for a specified role,
// such as the GUEST_PROPERTY_KEY role for the access web app. (NOTE: This does not
// currently factor in filtering by unit group)
function selectAccessPointSchedulesByRole(accessPoint, role) {
    var _a;
    var timezone = accessPoint.property.timezone;
    var roleId = role.roleId, permissionKeys = role.permissionKeys;
    var timezonedDate = (0, timetable_verification_1.getTimezonedDate)(new Date(), timezone);
    var defaultSchedules = (0, timetable_verification_1.filterTimetable)(timezonedDate, accessPoint.timetable, timezone);
    if (permissionKeys.includes(hasura_1.PermissionKey_enum.AccessPoint_BypassSchedule)) {
        var unlockedSchedules = (0, timetable_verification_1.selectUnlockedSchedules)(defaultSchedules);
        return (unlockedSchedules === null || unlockedSchedules === void 0 ? void 0 : unlockedSchedules.length) ? unlockedSchedules : null;
    }
    var roleSchedules = (_a = accessPoint.accessPointRoles.find(function (a) { return (a.roleId === roleId && a.hasAccess); })) === null || _a === void 0 ? void 0 : _a.schedule;
    var controlledSchedules = Array.isArray(roleSchedules)
        ? roleSchedules.map(function (rule) { return (__assign(__assign({}, rule), { state: main_api_1.TimetableRuleState.CONTROLLED })); })
        : (0, timetable_verification_1.selectControlledSchedules)(defaultSchedules);
    var combinedSchedules = __spreadArray(__spreadArray([], controlledSchedules, true), (0, timetable_verification_1.selectUncontrolledSchedules)(defaultSchedules), true);
    return combinedSchedules.length ? combinedSchedules : null;
}
//# sourceMappingURL=selectAccessPointSchedulesByRole.js.map